module.exports = __webpack_public_path__ + "static/06_Masterplan_1920_over-bd613a39de8b478543a5072ab25118a4.png";